module.exports = __webpack_public_path__ + "img/25.bde3c715.png";